import React, { createContext, useContext, useState } from 'react'

export interface FormBuilderChild {
    id: string
    type: string
    label: string
    isInfo: boolean
    isMandatory: boolean
    options?: { label: string; value: string }[]
    placeholder?: string
    inputType?: string
    variant?: 'primary' | 'secondary'
    size?: 'sm' | 'md' | 'lg'
    leftIcon?: string
    rightIcon?: string
    buttonClassName?: string
}

export interface FormBuilderRow {
    id: string
    isDataRow: boolean
    childData: FormBuilderChild[]
}

export interface FormBuilderContainer {
    id: string
    rowData: FormBuilderRow[]
}

export interface FormBuilderSchema {
    containersData: FormBuilderContainer[]
    selectedLayout: Record<string, number[]>
}

interface FormBuilderContextType {
    schema: FormBuilderSchema | null
    registerSchema: (schema: FormBuilderSchema) => void
    clearSchema: () => void
}

const FormBuilderContext = createContext<FormBuilderContextType>({
    schema: null,
    registerSchema: () => undefined,
    clearSchema: () => undefined,
})

export const FormBuilderContextProvider = ({ children }: { children: React.ReactNode }) => {
    const [schema, setSchema] = useState<FormBuilderSchema | null>(null)

    const registerSchema = (s: FormBuilderSchema) => setSchema(s)
    const clearSchema = () => setSchema(null)

    return (
        <FormBuilderContext.Provider value={{ schema, registerSchema, clearSchema }}>
            {children}
        </FormBuilderContext.Provider>
    )
}

export const useFormBuilderContext = () => useContext(FormBuilderContext)
